import _ from 'lodash'
import { diff } from 'deep-object-diff'

export default {
  /**
   * src1 と src2 を比較する.
   * 型の違いは無視する. 例えば、文字列の '123.000' と数値の 123 は一致と判定する.
   * @param {*} src1
   * @param {*} src2
   * @param {*} isAllowNull
   * @returns true の場合、一致.
   */
  compare (src1, src2, isAllowNull = false) {
    if (src1 === src2) {
      return true
    } else if (!isAllowNull && (src1 === null || src2 === null)) {
      return false
    }

    if (typeof src1 === 'object' && typeof src2 === 'object') {
      let sorted1 = src1
      let sorted2 = src2
      if (Array.isArray(src1) && Array.isArray(src2)) {
        sorted1 = _.sortBy(src1)
        sorted2 = _.sortBy(src2)
      }
      let src1Keys = Object.keys(sorted1).sort()
      let src2Keys = Object.keys(sorted2).sort()
      if (src1Keys.length === 0 && src2Keys.length === 0) {
        return sorted1.toString() === sorted2.toString()
      } else if (src1Keys.toString() !== src2Keys.toString()) {
        return false
      }
      let wrongIndex = src1Keys.findIndex((value) => {
        return !this.compare(sorted1[value], sorted2[value])
      })
      return wrongIndex === -1
    }
    return equals(src1, src2)
  },
  /**
   * src1 と src2の差分を抽出する.
   * 型の違いは差分として抽出される.
   * @param {*} src1
   * @param {*} src2
   * @param {*} isAllowNull
   */
  diff (src1, src2, isAllowNull = false) {
    let result
    if (isAllowNull) {
      // NULL/空配列時は''とし、片方がNULLになった場合でも判定できるようにする
      let source1 = _.cloneDeep(src1)
      let source2 = _.cloneDeep(src2)
      source1 = convert(source1)
      source2 = convert(source2)
      const diffResult = diff(source1, source2)
      result = returnValue(src2, diffResult)
    } else {
      result = diff(src1, src2)
    }
    return removeMatches(src1, result)
  }
}

function removeMatches (src, dest) {
  if (typeof src === 'object' && typeof dest === 'object') {
    Object.keys(dest).forEach(key => {
      if ((src[key] == null && dest[key] == null) || (src[key] != null && dest[key] != null)) {
        if (src[key] instanceof Date && dest[key] instanceof Date) {
          if (src[key].getTime() === dest[key].getTime()) {
            delete dest[key]
          }
        } else if (typeof src[key] === 'object' && typeof dest[key] === 'object') {
          dest[key] = removeMatches(src[key], dest[key])
          if (dest[key] && Object.keys(dest[key]).length === 0) {
            delete dest[key]
          }
        } else if (typeof src[key] !== 'object' && typeof dest[key] !== 'object') {
          if (equals(src[key], dest[key])) {
            delete dest[key]
          }
        }
      }
    })
  }
  return dest
};

function equals (val1, val2) {
  if (typeof val1 === 'number' || typeof val2 === 'number') {
    return Number(val1) === Number(val2)
  }
  return val1 != null && val2 != null && val1.toString() === val2.toString()
}

function convert (source) {
  Object.keys(source).forEach((key) => {
    if (!Array.isArray(source[key]) && typeof source[key] === 'object') {
      if (source[key] == null) {
        source[key] = ''
      } else {
        source[key] = convert(source[key])
      }
    } else {
      if (source[key] == null) {
        source[key] = ''
      } else if (Array.isArray(source[key])) {
        if (source[key].length === 0) {
          source[key] = ''
        } else {
          for (let child of source[key]) {
            child = convert(child)
          }
        }
      }
    }
  })
  return source
}

function returnValue (value, diffResult) {
  const returnObject = {}
  Object.keys(value || {}).forEach((key) => {
    let addObject = {}
    if (key in (diffResult || [])) {
      if (!Array.isArray(value[key]) && typeof value[key] === 'object') {
        const addValue = returnValue(value[key], diffResult[key])
        if (Object.keys(addValue).length) addObject = { [key]: addValue }
      } else {
        if (Array.isArray(value[key])) {
          const addArray = []
          if (value[key].length > 0) {
            for (let index in value[key]) {
              if (Array.isArray(value[key][index]) || typeof value[key][index] === 'object') {
                const addValue = returnValue(value[key][index], diffResult[key][index])
                if (Object.keys(addValue).length) addArray[index] = addValue
              } else {
                addArray[index] = value[key][index]
              }
            }
            addObject = { [key]: addArray }
          } else {
            addObject = { [key]: value[key] }
          }
        } else {
          addObject = { [key]: value[key] }
        }
      }
      Object.assign(returnObject, addObject)
    }
  })
  return returnObject
}



// WEBPACK FOOTER //
// ./src/utils/compareUtils.js